function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

_AsyncGenerator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; };

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) method = iterable[Symbol.asyncIterator]; if (method == null && Symbol.iterator) method = iterable[Symbol.iterator]; } if (method == null) method = iterable["@@asyncIterator"]; if (method == null) method = iterable["@@iterator"]; if (method == null) throw new TypeError("Object is not async iterable"); return method.call(iterable); }

import { greatest, reverse } from "d3-array";
import { FileAttachment } from "./fileAttachment.js";
import { isArqueroTable } from "./arquero.js";
import { isArrowTable, loadArrow } from "./arrow.js";
import { DuckDBClient } from "./duckdb.js";
var nChecks = 20; // number of values to check in each array
// We support two levels of DatabaseClient. The simplest DatabaseClient
// implements only the client.sql tagged template literal. More advanced
// DatabaseClients implement client.query and client.queryStream, which support
// streaming and abort, and the client.queryTag tagged template literal is used
// to translate the contents of a SQL cell or Table cell into the appropriate
// arguments for calling client.query or client.queryStream. For table cells, we
// additionally require client.describeColumns. The client.describeTables method
// is optional.

export function isDatabaseClient(value, mode) {
  return value && (typeof value.sql === "function" || typeof value.queryTag === "function" && (typeof value.query === "function" || typeof value.queryStream === "function")) && (mode !== "table" || typeof value.describeColumns === "function") && value !== __query // don’t match our internal helper
  ;
} // Returns true if the value is a typed array (for a single-column table), or if
// it’s an array. In the latter case, the elements of the array must be
// consistently typed: either plain objects or primitives or dates.

export function isDataArray(value) {
  return Array.isArray(value) && (isQueryResultSetSchema(value.schema) || isQueryResultSetColumns(value.columns) || arrayContainsObjects(value) || arrayContainsPrimitives(value) || arrayContainsDates(value)) || isTypedArray(value);
} // Given an array, checks that the given value is an array that does not contain
// any primitive values (at least for the first few values that we check), and
// that the first object contains enumerable keys (see computeSchema for how we
// infer the columns). We assume that the contents of the table are homogenous,
// but we don’t currently enforce this.
// https://observablehq.com/@observablehq/database-client-specification#§1

function arrayContainsObjects(value) {
  var n = Math.min(nChecks, value.length);

  for (var i = 0; i < n; ++i) {
    var v = value[i];
    if (v === null || _typeof(v) !== "object") return false;
  }

  return n > 0 && objectHasEnumerableKeys(value[0]);
} // Using a for-in loop here means that we can abort after finding at least one
// enumerable key (whereas Object.keys would require materializing the array of
// all keys, which would be considerably slower if the value has many keys!).
// This function assumes that value is an object; see arrayContainsObjects.


function objectHasEnumerableKeys(value) {
  for (var _ in value) {
    return true;
  }

  return false;
}

function isQueryResultSetSchema(schemas) {
  return Array.isArray(schemas) && schemas.every(isColumnSchema);
}

function isQueryResultSetColumns(columns) {
  return Array.isArray(columns) && columns.every(function (name) {
    return typeof name === "string";
  });
}

function isColumnSchema(schema) {
  return schema && typeof schema.name === "string" && typeof schema.type === "string";
} // Returns true if the value represents an array of primitives (i.e., a
// single-column table). This should only be passed values for which
// isDataArray returns true.


export function arrayIsPrimitive(value) {
  return isTypedArray(value) || arrayContainsPrimitives(value) || arrayContainsDates(value);
} // Given an array, checks that the first n elements are primitives (number,
// string, boolean, bigint) of a consistent type.

function arrayContainsPrimitives(value) {
  var n = Math.min(nChecks, value.length);
  if (!(n > 0)) return false;
  var type;
  var hasPrimitive = false; // ensure we encounter 1+ primitives

  for (var i = 0; i < n; ++i) {
    var v = value[i];
    if (v == null) continue; // ignore null and undefined

    var t = _typeof(v);

    if (type === undefined) {
      switch (t) {
        case "number":
        case "boolean":
        case "string":
        case "bigint":
          type = t;
          break;

        default:
          return false;
      }
    } else if (t !== type) {
      return false;
    }

    hasPrimitive = true;
  }

  return hasPrimitive;
} // Given an array, checks that the first n elements are dates.


function arrayContainsDates(value) {
  var n = Math.min(nChecks, value.length);
  if (!(n > 0)) return false;
  var hasDate = false; // ensure we encounter 1+ dates

  for (var i = 0; i < n; ++i) {
    var v = value[i];
    if (v == null) continue; // ignore null and undefined

    if (!(v instanceof Date)) return false;
    hasDate = true;
  }

  return hasDate;
}

function isTypedArray(value) {
  return value instanceof Int8Array || value instanceof Int16Array || value instanceof Int32Array || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Uint16Array || value instanceof Uint32Array || value instanceof Float32Array || value instanceof Float64Array;
} // __query is used by table cells; __query.sql is used by SQL cells.


export var __query = Object.assign( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, operations, invalidation, name) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = loadTableDataSource;
            _context.next = 3;
            return source;

          case 3:
            _context.t1 = _context.sent;
            _context.t2 = name;
            _context.next = 7;
            return (0, _context.t0)(_context.t1, _context.t2);

          case 7:
            source = _context.sent;

            if (!isDatabaseClient(source)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", evaluateQuery(source, makeQueryTemplate(operations, source), invalidation));

          case 10:
            if (!isDataArray(source)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", __table(source, operations));

          case 12:
            if (source) {
              _context.next = 14;
              break;
            }

            throw new Error("missing data source");

          case 14:
            throw new Error("invalid data source");

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}(), {
  sql: function sql(source, invalidation, name) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = evaluateQuery;
              _context2.t1 = loadSqlDataSource;
              _context2.next = 4;
              return source;

            case 4:
              _context2.t2 = _context2.sent;
              _context2.t3 = name;
              _context2.next = 8;
              return (0, _context2.t1)(_context2.t2, _context2.t3);

            case 8:
              _context2.t4 = _context2.sent;
              _context2.t5 = _args2;
              _context2.t6 = invalidation;
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t4, _context2.t5, _context2.t6));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }
});
export function loadDataSource(_x6, _x7, _x8) {
  return _loadDataSource.apply(this, arguments);
} // We use a weak map to cache loaded data sources by key so that we don’t have
// to e.g. create separate SQLiteDatabaseClients every time we’re querying the
// same SQLite file attachment. Since this is a weak map, unused references will
// be garbage collected when they are no longer desired. Note: the name should
// be consistent, as it is not part of the cache key!

function _loadDataSource() {
  _loadDataSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(source, mode, name) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = mode;
            _context7.next = _context7.t0 === "chart" ? 3 : _context7.t0 === "table" ? 4 : _context7.t0 === "sql" ? 5 : 6;
            break;

          case 3:
            return _context7.abrupt("return", loadChartDataSource(source));

          case 4:
            return _context7.abrupt("return", loadTableDataSource(source, name));

          case 5:
            return _context7.abrupt("return", loadSqlDataSource(source, name));

          case 6:
            return _context7.abrupt("return", source);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _loadDataSource.apply(this, arguments);
}

function sourceCache(loadSource) {
  var cache = new WeakMap();
  return function (source, name) {
    if (!source) throw new Error("data source not found");
    var promise = cache.get(source);

    if (!promise || isDataArray(source) && source.length !== promise._numRows) {
      // Warning: do not await here! We need to populate the cache synchronously.
      promise = loadSource(source, name);
      promise._numRows = source.length; // This will be undefined for DatabaseClients

      cache.set(source, promise);
    }

    return promise;
  };
}

var loadChartDataSource = sourceCache( /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(source instanceof FileAttachment)) {
              _context3.next = 8;
              break;
            }

            _context3.t0 = source.mimeType;
            _context3.next = _context3.t0 === "text/csv" ? 4 : _context3.t0 === "text/tab-separated-values" ? 5 : _context3.t0 === "application/json" ? 6 : 7;
            break;

          case 4:
            return _context3.abrupt("return", source.csv({
              typed: "auto"
            }));

          case 5:
            return _context3.abrupt("return", source.tsv({
              typed: "auto"
            }));

          case 6:
            return _context3.abrupt("return", source.json());

          case 7:
            throw new Error("unsupported file type: ".concat(source.mimeType));

          case 8:
            return _context3.abrupt("return", source);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x9) {
    return _ref3.apply(this, arguments);
  };
}());
var loadTableDataSource = sourceCache( /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(source, name) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(source instanceof FileAttachment)) {
              _context4.next = 11;
              break;
            }

            _context4.t0 = source.mimeType;
            _context4.next = _context4.t0 === "text/csv" ? 4 : _context4.t0 === "text/tab-separated-values" ? 5 : _context4.t0 === "application/json" ? 6 : _context4.t0 === "application/x-sqlite3" ? 7 : 8;
            break;

          case 4:
            return _context4.abrupt("return", source.csv());

          case 5:
            return _context4.abrupt("return", source.tsv());

          case 6:
            return _context4.abrupt("return", source.json());

          case 7:
            return _context4.abrupt("return", source.sqlite());

          case 8:
            if (!/\.(arrow|parquet)$/i.test(source.name)) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("return", loadDuckDBClient(source, name));

          case 10:
            throw new Error("unsupported file type: ".concat(source.mimeType));

          case 11:
            if (!(isArrowTable(source) || isArqueroTable(source))) {
              _context4.next = 13;
              break;
            }

            return _context4.abrupt("return", loadDuckDBClient(source, name));

          case 13:
            if (!(isDataArray(source) && arrayIsPrimitive(source))) {
              _context4.next = 15;
              break;
            }

            return _context4.abrupt("return", Array.from(source, function (value) {
              return {
                value: value
              };
            }));

          case 15:
            return _context4.abrupt("return", source);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}());
var loadSqlDataSource = sourceCache( /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(source, name) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(source instanceof FileAttachment)) {
              _context5.next = 9;
              break;
            }

            _context5.t0 = source.mimeType;
            _context5.next = _context5.t0 === "text/csv" ? 4 : _context5.t0 === "text/tab-separated-values" ? 4 : _context5.t0 === "application/json" ? 4 : _context5.t0 === "application/x-sqlite3" ? 5 : 6;
            break;

          case 4:
            return _context5.abrupt("return", loadDuckDBClient(source, name));

          case 5:
            return _context5.abrupt("return", source.sqlite());

          case 6:
            if (!/\.(arrow|parquet)$/i.test(source.name)) {
              _context5.next = 8;
              break;
            }

            return _context5.abrupt("return", loadDuckDBClient(source, name));

          case 8:
            throw new Error("unsupported file type: ".concat(source.mimeType));

          case 9:
            if (!isDataArray(source)) {
              _context5.next = 16;
              break;
            }

            _context5.t1 = loadDuckDBClient;
            _context5.next = 13;
            return asArrowTable(source, name);

          case 13:
            _context5.t2 = _context5.sent;
            _context5.t3 = name;
            return _context5.abrupt("return", (0, _context5.t1)(_context5.t2, _context5.t3));

          case 16:
            if (!(isArrowTable(source) || isArqueroTable(source))) {
              _context5.next = 18;
              break;
            }

            return _context5.abrupt("return", loadDuckDBClient(source, name));

          case 18:
            return _context5.abrupt("return", source);

          case 19:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x12, _x13) {
    return _ref5.apply(this, arguments);
  };
}());

function asArrowTable(_x14, _x15) {
  return _asArrowTable.apply(this, arguments);
}

function _asArrowTable() {
  _asArrowTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(array, name) {
    var arrow;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return loadArrow();

          case 2:
            arrow = _context8.sent;
            return _context8.abrupt("return", arrayIsPrimitive(array) ? arrow.tableFromArrays(_defineProperty({}, name, array)) : arrow.tableFromJSON(array));

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _asArrowTable.apply(this, arguments);
}

function loadDuckDBClient(source) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : source instanceof FileAttachment ? getFileSourceName(source) : "__table";
  return DuckDBClient.of(_defineProperty({}, name, source));
}

function getFileSourceName(file) {
  return file.name.replace(/@\d+(?=\.|$)/, "") // strip Observable file version number
  .replace(/\.\w+$/, ""); // strip file extension
}

function evaluateQuery(_x16, _x17, _x18) {
  return _evaluateQuery.apply(this, arguments);
} // Generator function that yields accumulated query results client.queryStream


function _evaluateQuery() {
  _evaluateQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(source, args, invalidation) {
    var abortController, options;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (source) {
              _context9.next = 2;
              break;
            }

            throw new Error("missing data source");

          case 2:
            if (!(typeof source.queryTag === "function")) {
              _context9.next = 10;
              break;
            }

            abortController = new AbortController();
            options = {
              signal: abortController.signal
            };
            invalidation.then(function () {
              return abortController.abort("invalidated");
            });

            if (!(typeof source.queryStream === "function")) {
              _context9.next = 8;
              break;
            }

            return _context9.abrupt("return", accumulateQuery(source.queryStream.apply(source, _toConsumableArray(source.queryTag.apply(source, args)).concat([options]))));

          case 8:
            if (!(typeof source.query === "function")) {
              _context9.next = 10;
              break;
            }

            return _context9.abrupt("return", source.query.apply(source, _toConsumableArray(source.queryTag.apply(source, args)).concat([options])));

          case 10:
            if (!(typeof source.sql === "function")) {
              _context9.next = 12;
              break;
            }

            return _context9.abrupt("return", source.sql.apply(source, args));

          case 12:
            throw new Error("source does not implement query, queryStream, or sql");

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _evaluateQuery.apply(this, arguments);
}

function accumulateQuery(_x) {
  return _accumulateQuery.apply(this, arguments);
}
/**
 * Returns a SQL query in the form [[parts], ...params] where parts is an array
 * of sub-strings and params are the parameter values to be inserted between each
 * sub-string.
 */


function _accumulateQuery() {
  _accumulateQuery = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(queryRequest) {
    var then, queryResponse, values, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, rows, _iterator2, _step2, value;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            then = performance.now();
            _context6.next = 3;
            return _awaitAsyncGenerator(queryRequest);

          case 3:
            queryResponse = _context6.sent;
            values = [];
            values.done = false;
            values.error = null;
            values.schema = queryResponse.schema;
            _context6.prev = 8;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context6.prev = 11;
            _iterator = _asyncIterator(queryResponse.readRows());

          case 13:
            _context6.next = 15;
            return _awaitAsyncGenerator(_iterator.next());

          case 15:
            _step = _context6.sent;
            _iteratorNormalCompletion = _step.done;
            _context6.next = 19;
            return _awaitAsyncGenerator(_step.value);

          case 19:
            _value = _context6.sent;

            if (_iteratorNormalCompletion) {
              _context6.next = 31;
              break;
            }

            rows = _value;

            if (!(performance.now() - then > 150 && values.length > 0)) {
              _context6.next = 26;
              break;
            }

            _context6.next = 25;
            return values;

          case 25:
            then = performance.now();

          case 26:
            _iterator2 = _createForOfIteratorHelper(rows);

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                value = _step2.value;
                values.push(value);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

          case 28:
            _iteratorNormalCompletion = true;
            _context6.next = 13;
            break;

          case 31:
            _context6.next = 37;
            break;

          case 33:
            _context6.prev = 33;
            _context6.t0 = _context6["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context6.t0;

          case 37:
            _context6.prev = 37;
            _context6.prev = 38;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context6.next = 42;
              break;
            }

            _context6.next = 42;
            return _awaitAsyncGenerator(_iterator.return());

          case 42:
            _context6.prev = 42;

            if (!_didIteratorError) {
              _context6.next = 45;
              break;
            }

            throw _iteratorError;

          case 45:
            return _context6.finish(42);

          case 46:
            return _context6.finish(37);

          case 47:
            values.done = true;
            _context6.next = 50;
            return values;

          case 50:
            _context6.next = 57;
            break;

          case 52:
            _context6.prev = 52;
            _context6.t1 = _context6["catch"](8);
            values.error = _context6.t1;
            _context6.next = 57;
            return values;

          case 57:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[8, 52], [11, 33, 37, 47], [38,, 42, 46]]);
  }));
  return _accumulateQuery.apply(this, arguments);
}

export function makeQueryTemplate(operations, source) {
  var _operations$names;

  var escaper = typeof source.escape === "function" ? source.escape : function (i) {
    return i;
  };
  var select = operations.select,
      from = operations.from,
      filter = operations.filter,
      sort = operations.sort,
      slice = operations.slice;
  if (!from.table) throw new Error("missing from table");
  if (select.columns && select.columns.length === 0) throw new Error("at least one column must be selected");
  var names = new Map((_operations$names = operations.names) === null || _operations$names === void 0 ? void 0 : _operations$names.map(function (_ref6) {
    var column = _ref6.column,
        name = _ref6.name;
    return [column, name];
  }));
  var columns = select.columns ? select.columns.map(function (column) {
    var override = names.get(column);
    return override ? "".concat(escaper(column), " AS ").concat(escaper(override)) : escaper(column);
  }).join(", ") : "*";
  var args = [["SELECT ".concat(columns, " FROM ").concat(formatTable(from.table, escaper))]];

  for (var i = 0; i < filter.length; ++i) {
    appendSql(i ? "\nAND " : "\nWHERE ", args);
    appendWhereEntry(filter[i], args, escaper);
  }

  for (var _i = 0; _i < sort.length; ++_i) {
    appendSql(_i ? ", " : "\nORDER BY ", args);
    appendOrderBy(sort[_i], args, escaper);
  }

  if (source.dialect === "mssql" || source.dialect === "oracle") {
    if (slice.to !== null || slice.from !== null) {
      if (!sort.length) {
        if (!select.columns) throw new Error("at least one column must be explicitly specified. Received '*'.");
        appendSql("\nORDER BY ", args);
        appendOrderBy({
          column: select.columns[0],
          direction: "ASC"
        }, args, escaper);
      }

      appendSql("\nOFFSET ".concat(slice.from || 0, " ROWS"), args);
      appendSql("\nFETCH NEXT ".concat(slice.to !== null ? slice.to - (slice.from || 0) : 1e9, " ROWS ONLY"), args);
    }
  } else {
    if (slice.to !== null || slice.from !== null) {
      appendSql("\nLIMIT ".concat(slice.to !== null ? slice.to - (slice.from || 0) : 1e9), args);
    }

    if (slice.from !== null) {
      appendSql(" OFFSET ".concat(slice.from), args);
    }
  }

  return args;
}

function formatTable(table, escaper) {
  if (_typeof(table) === "object") {
    // i.e., not a bare string specifier
    var from = "";
    if (table.database != null) from += escaper(table.database) + ".";
    if (table.schema != null) from += escaper(table.schema) + ".";
    from += escaper(table.table);
    return from;
  } else {
    return escaper(table);
  }
}

function appendSql(sql, args) {
  var strings = args[0];
  strings[strings.length - 1] += sql;
}

function appendOrderBy(_ref7, args, escaper) {
  var column = _ref7.column,
      direction = _ref7.direction;
  appendSql("".concat(escaper(column), " ").concat(direction.toUpperCase()), args);
}

function appendWhereEntry(_ref8, args, escaper) {
  var type = _ref8.type,
      operands = _ref8.operands;
  if (operands.length < 1) throw new Error("Invalid operand length"); // Unary operations
  // We treat `v` and `nv` as `NULL` and `NOT NULL` unary operations in SQL,
  // since the database already validates column types.

  if (operands.length === 1 || type === "v" || type === "nv") {
    appendOperand(operands[0], args, escaper);

    switch (type) {
      case "n":
      case "nv":
        appendSql(" IS NULL", args);
        return;

      case "nn":
      case "v":
        appendSql(" IS NOT NULL", args);
        return;

      default:
        throw new Error("Invalid filter operation");
    }
  } // Binary operations


  if (operands.length === 2) {
    if (["in", "nin"].includes(type)) {// Fallthrough to next parent block.
    } else if (["c", "nc"].includes(type)) {
      // TODO: Case (in)sensitive?
      appendOperand(operands[0], args, escaper);

      switch (type) {
        case "c":
          appendSql(" LIKE ", args);
          break;

        case "nc":
          appendSql(" NOT LIKE ", args);
          break;
      }

      appendOperand(likeOperand(operands[1]), args, escaper);
      return;
    } else {
      appendOperand(operands[0], args, escaper);

      switch (type) {
        case "eq":
          appendSql(" = ", args);
          break;

        case "ne":
          appendSql(" <> ", args);
          break;

        case "gt":
          appendSql(" > ", args);
          break;

        case "lt":
          appendSql(" < ", args);
          break;

        case "gte":
          appendSql(" >= ", args);
          break;

        case "lte":
          appendSql(" <= ", args);
          break;

        default:
          throw new Error("Invalid filter operation");
      }

      appendOperand(operands[1], args, escaper);
      return;
    }
  } // List operations


  appendOperand(operands[0], args, escaper);

  switch (type) {
    case "in":
      appendSql(" IN (", args);
      break;

    case "nin":
      appendSql(" NOT IN (", args);
      break;

    default:
      throw new Error("Invalid filter operation");
  }

  appendListOperands(operands.slice(1), args);
  appendSql(")", args);
}

function appendOperand(o, args, escaper) {
  if (o.type === "column") {
    appendSql(escaper(o.value), args);
  } else {
    args.push(o.value);
    args[0].push("");
  }
} // TODO: Support column operands here?


function appendListOperands(ops, args) {
  var first = true;

  var _iterator3 = _createForOfIteratorHelper(ops),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var op = _step3.value;
      if (first) first = false;else appendSql(",", args);
      args.push(op.value);
      args[0].push("");
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

function likeOperand(operand) {
  return _objectSpread(_objectSpread({}, operand), {}, {
    value: "%".concat(operand.value, "%")
  });
} // Comparator function that moves null values (undefined, null, NaN) to the
// end of the array.


function defined(a, b) {
  return (a == null || !(a >= a)) - (b == null || !(b >= b));
} // Comparator function that sorts values in ascending order, with null values at
// the end.


function ascendingDefined(a, b) {
  return defined(a, b) || (a < b ? -1 : a > b ? 1 : 0);
} // Comparator function that sorts values in descending order, with null values
// at the end.


function descendingDefined(a, b) {
  return defined(a, b) || (a > b ? -1 : a < b ? 1 : 0);
} // Functions for checking type validity


var isValidNumber = function isValidNumber(value) {
  return typeof value === "number" && !Number.isNaN(value);
};

var isValidInteger = function isValidInteger(value) {
  return Number.isInteger(value) && !Number.isNaN(value);
};

var isValidString = function isValidString(value) {
  return typeof value === "string";
};

var isValidBoolean = function isValidBoolean(value) {
  return typeof value === "boolean";
};

var isValidBigint = function isValidBigint(value) {
  return typeof value === "bigint";
};

var isValidDate = function isValidDate(value) {
  return value instanceof Date && !isNaN(value);
};

var isValidBuffer = function isValidBuffer(value) {
  return value instanceof ArrayBuffer;
};

var isValidArray = function isValidArray(value) {
  return Array.isArray(value);
};

var isValidObject = function isValidObject(value) {
  return _typeof(value) === "object" && value !== null;
};

var isValidOther = function isValidOther(value) {
  return value != null;
}; // Function to get the correct validity checking function based on type


export function getTypeValidator(colType) {
  switch (colType) {
    case "string":
      return isValidString;

    case "bigint":
      return isValidBigint;

    case "boolean":
      return isValidBoolean;

    case "number":
      return isValidNumber;

    case "integer":
      return isValidInteger;

    case "date":
      return isValidDate;

    case "buffer":
      return isValidBuffer;

    case "array":
      return isValidArray;

    case "object":
      return isValidObject;

    case "other":
    default:
      return isValidOther;
  }
} // Accepts dates in the form of ISOString and LocaleDateString, with or without time

var DATE_TEST = /^(([-+]\d{2})?\d{4}(-\d{2}(-\d{2}))|(\d{1,2})\/(\d{1,2})\/(\d{2,4}))([T ]\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/;
export function coerceToType(value, type) {
  switch (type) {
    case "string":
      return typeof value === "string" || value == null ? value : String(value);

    case "boolean":
      if (typeof value === "string") {
        var trimValue = value.trim().toLowerCase();
        return trimValue === "true" ? true : trimValue === "false" ? false : null;
      }

      return typeof value === "boolean" || value == null ? value : Boolean(value);

    case "bigint":
      return typeof value === "bigint" || value == null ? value : Number.isInteger(typeof value === "string" && !value.trim() ? NaN : +value) ? BigInt(value) // eslint-disable-line no-undef
      : undefined;

    case "integer": // not a target type for coercion, but can be inferred

    case "number":
      {
        return typeof value === "number" ? value : value == null || typeof value === "string" && !value.trim() ? NaN : Number(value);
      }

    case "date":
      {
        if (value instanceof Date || value == null) return value;
        if (typeof value === "number") return new Date(value);

        var _trimValue = String(value).trim();

        if (typeof value === "string" && !_trimValue) return null;
        return new Date(DATE_TEST.test(_trimValue) ? _trimValue : NaN);
      }

    case "array":
    case "object":
    case "buffer":
    case "other":
      return value;

    default:
      throw new Error("Unable to coerce to type: ".concat(type));
  }
}
export function getSchema(source) {
  var columns = source.columns;
  var schema = source.schema;

  if (!isQueryResultSetSchema(schema)) {
    schema = inferSchema(source, isQueryResultSetColumns(columns) ? columns : undefined);
    return {
      schema: schema,
      inferred: true
    };
  }

  return {
    schema: schema,
    inferred: false
  };
} // This function infers a schema from the source data, if one doesn't already
// exist, and merges type assertions into that schema. If the schema was
// inferred or if there are type assertions, it then coerces the rows in the
// source data to the types specified in the schema.

function applyTypes(source, operations) {
  var input = source;

  var _getSchema = getSchema(source),
      schema = _getSchema.schema,
      inferred = _getSchema.inferred;

  var types = new Map(schema.map(function (_ref9) {
    var name = _ref9.name,
        type = _ref9.type;
    return [name, type];
  }));

  if (operations.types) {
    var _iterator4 = _createForOfIteratorHelper(operations.types),
        _step4;

    try {
      var _loop = function _loop() {
        var _ref10 = _step4.value;
        var name = _ref10.name;
        var type = _ref10.type;
        types.set(name, type); // update schema with user-selected type

        if (schema === input.schema) schema = schema.slice(); // copy on write

        var colIndex = schema.findIndex(function (col) {
          return col.name === name;
        });
        if (colIndex > -1) schema[colIndex] = _objectSpread(_objectSpread({}, schema[colIndex]), {}, {
          type: type
        });
      };

      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    source = source.map(function (d) {
      return coerceRow(d, types, schema);
    });
  } else if (inferred) {
    // Coerce data according to new schema, unless that happened due to
    // operations.types, above.
    source = source.map(function (d) {
      return coerceRow(d, types, schema);
    });
  }

  return {
    source: source,
    schema: schema
  };
}

function applyNames(source, operations) {
  if (!operations.names) return source;
  var overridesByName = new Map(operations.names.map(function (n) {
    return [n.column, n];
  }));
  return source.map(function (d) {
    return Object.fromEntries(Object.keys(d).map(function (k) {
      var _override$name;

      var override = overridesByName.get(k);
      return [(_override$name = override === null || override === void 0 ? void 0 : override.name) !== null && _override$name !== void 0 ? _override$name : k, d[k]];
    }));
  });
} // This function applies table cell operations to an in-memory table (array of
// objects); it should be equivalent to the corresponding SQL query. TODO Use
// DuckDBClient for data arrays, too, and then we wouldn’t need our own __table
// function to do table operations on in-memory data?


export function __table(source, operations) {
  var errors = new Map();
  var input = source;
  var typed = applyTypes(source, operations);
  source = typed.source;
  var schema = typed.schema;

  if (operations.derive) {
    // Derived columns may depend on coerced values from the original data source,
    // so we must evaluate derivations after the initial inference and coercion
    // step.
    var derivedSource = [];
    operations.derive.map(function (_ref11) {
      var name = _ref11.name,
          value = _ref11.value;
      var columnErrors = []; // Derived column formulas may reference renamed columns, so we must
      // compute derivations on the renamed source. However, we don't modify the
      // source itself with renamed names until after the other operations are
      // applied, because operations like filter and sort reference original
      // column names.
      // TODO Allow derived columns to reference other derived columns.

      applyNames(source, operations).map(function (row, index) {
        var resolved;

        try {
          // TODO Support referencing `index` and `rows` in the derive function.
          resolved = value(row);
        } catch (error) {
          columnErrors.push({
            index: index,
            error: error
          });
          resolved = undefined;
        }

        if (derivedSource[index]) {
          derivedSource[index] = _objectSpread(_objectSpread({}, derivedSource[index]), {}, _defineProperty({}, name, resolved));
        } else {
          derivedSource.push(_defineProperty({}, name, resolved));
        }
      });
      if (columnErrors.length) errors.set(name, columnErrors);
    }); // Since derived columns are untyped by default, we do a pass of type
    // inference and coercion after computing the derived values.

    var typedDerived = applyTypes(derivedSource, operations); // Merge derived source and schema with the source dataset.

    source = source.map(function (row, i) {
      return _objectSpread(_objectSpread({}, row), typedDerived.source[i]);
    });
    schema = [].concat(_toConsumableArray(schema), _toConsumableArray(typedDerived.schema));
  }

  var _iterator5 = _createForOfIteratorHelper(operations.filter),
      _step5;

  try {
    var _loop2 = function _loop2() {
      var _ref12 = _step5.value;
      var type = _ref12.type;
      var operands = _ref12.operands;

      var _operands = _slicedToArray(operands, 1),
          column = _operands[0].value;

      var values = operands.slice(1).map(function (_ref14) {
        var value = _ref14.value;
        return value;
      });

      switch (type) {
        // valid (matches the column type)
        case "v":
          {
            var _values = _slicedToArray(values, 1),
                colType = _values[0];

            var isValid = getTypeValidator(colType);
            source = source.filter(function (d) {
              return isValid(d[column]);
            });
            break;
          }
        // not valid (doesn't match the column type)

        case "nv":
          {
            var _values2 = _slicedToArray(values, 1),
                _colType = _values2[0];

            var _isValid = getTypeValidator(_colType);

            source = source.filter(function (d) {
              return !_isValid(d[column]);
            });
            break;
          }

        case "eq":
          {
            var _values3 = _slicedToArray(values, 1),
                value = _values3[0];

            if (value instanceof Date) {
              var time = +value; // compare as primitive

              source = source.filter(function (d) {
                return +d[column] === time;
              });
            } else {
              source = source.filter(function (d) {
                return d[column] === value;
              });
            }

            break;
          }

        case "ne":
          {
            var _values4 = _slicedToArray(values, 1),
                _value2 = _values4[0];

            source = source.filter(function (d) {
              return d[column] !== _value2;
            });
            break;
          }

        case "c":
          {
            var _values5 = _slicedToArray(values, 1),
                _value3 = _values5[0];

            source = source.filter(function (d) {
              return typeof d[column] === "string" && d[column].includes(_value3);
            });
            break;
          }

        case "nc":
          {
            var _values6 = _slicedToArray(values, 1),
                _value4 = _values6[0];

            source = source.filter(function (d) {
              return typeof d[column] === "string" && !d[column].includes(_value4);
            });
            break;
          }

        case "in":
          {
            var set = new Set(values); // TODO support dates?

            source = source.filter(function (d) {
              return set.has(d[column]);
            });
            break;
          }

        case "nin":
          {
            var _set = new Set(values); // TODO support dates?


            source = source.filter(function (d) {
              return !_set.has(d[column]);
            });
            break;
          }

        case "n":
          {
            source = source.filter(function (d) {
              return d[column] == null;
            });
            break;
          }

        case "nn":
          {
            source = source.filter(function (d) {
              return d[column] != null;
            });
            break;
          }

        case "lt":
          {
            var _values7 = _slicedToArray(values, 1),
                _value5 = _values7[0];

            source = source.filter(function (d) {
              return d[column] < _value5;
            });
            break;
          }

        case "lte":
          {
            var _values8 = _slicedToArray(values, 1),
                _value6 = _values8[0];

            source = source.filter(function (d) {
              return d[column] <= _value6;
            });
            break;
          }

        case "gt":
          {
            var _values9 = _slicedToArray(values, 1),
                _value7 = _values9[0];

            source = source.filter(function (d) {
              return d[column] > _value7;
            });
            break;
          }

        case "gte":
          {
            var _values10 = _slicedToArray(values, 1),
                _value8 = _values10[0];

            source = source.filter(function (d) {
              return d[column] >= _value8;
            });
            break;
          }

        default:
          throw new Error("unknown filter type: ".concat(type));
      }
    };

    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var _iterator6 = _createForOfIteratorHelper(reverse(operations.sort)),
      _step6;

  try {
    var _loop3 = function _loop3() {
      var _ref13 = _step6.value;
      var column = _ref13.column;
      var direction = _ref13.direction;
      var compare = direction === "desc" ? descendingDefined : ascendingDefined;
      if (source === input) source = source.slice(); // defensive copy

      source.sort(function (a, b) {
        return compare(a[column], b[column]);
      });
    };

    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  var _operations$slice = operations.slice,
      from = _operations$slice.from,
      to = _operations$slice.to;
  from = from == null ? 0 : Math.max(0, from);
  to = to == null ? Infinity : Math.max(0, to);

  if (from > 0 || to < Infinity) {
    source = source.slice(Math.max(0, from), Math.max(0, to));
  } // Preserve the schema for all columns.


  var fullSchema = schema.slice();

  if (operations.select.columns) {
    if (schema) {
      var schemaByName = new Map(schema.map(function (s) {
        return [s.name, s];
      }));
      schema = operations.select.columns.map(function (c) {
        return schemaByName.get(c);
      });
    }

    source = source.map(function (d) {
      return Object.fromEntries(operations.select.columns.map(function (c) {
        return [c, d[c]];
      }));
    });
  }

  if (operations.names) {
    var overridesByName = new Map(operations.names.map(function (n) {
      return [n.column, n];
    }));

    if (schema) {
      schema = schema.map(function (s) {
        var override = overridesByName.get(s.name);
        return _objectSpread(_objectSpread({}, s), override ? {
          name: override.name
        } : null);
      });
    }

    if (fullSchema) {
      fullSchema = fullSchema.map(function (s) {
        var override = overridesByName.get(s.name);
        return _objectSpread(_objectSpread({}, s), override ? {
          name: override.name
        } : null);
      });
    }

    source = applyNames(source, operations);
  }

  if (source !== input) {
    if (schema) source.schema = schema;
  }

  source.fullSchema = fullSchema;
  source.errors = errors;
  return source;
}
export function coerceRow(object, types, schema) {
  var coerced = {};

  var _iterator7 = _createForOfIteratorHelper(schema),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var col = _step7.value;
      var type = types.get(col.name);
      var value = object[col.name];
      coerced[col.name] = type === "raw" ? value : coerceToType(value, type);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return coerced;
}

function createTypeCount() {
  return {
    boolean: 0,
    integer: 0,
    number: 0,
    date: 0,
    string: 0,
    array: 0,
    object: 0,
    bigint: 0,
    buffer: 0,
    defined: 0
  };
} // Caution: the order below matters! 🌶️ The first one that passes the ≥90% test
// should be the one that we chose, and therefore these types should be listed
// from most specific to least specific.


var types = ["boolean", "integer", "number", "date", "bigint", "array", "object", "buffer" // Note: "other" and "string" are intentionally omitted; see below!
]; // We need to show *all* keys present in the array of Objects

function getAllKeys(rows) {
  var keys = new Set();

  var _iterator8 = _createForOfIteratorHelper(rows),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var row = _step8.value;

      // avoid crash if row is null or undefined
      if (row) {
        // only enumerable properties
        for (var key in row) {
          // only own properties
          if (Object.prototype.hasOwnProperty.call(row, key)) {
            // unique properties, in the order they appear
            keys.add(key);
          }
        }
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return Array.from(keys);
}

export function inferSchema(source) {
  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getAllKeys(source);
  var schema = [];
  var sampleSize = 100;
  var sample = source.slice(0, sampleSize);
  var typeCounts = {};

  var _iterator9 = _createForOfIteratorHelper(columns),
      _step9;

  try {
    var _loop4 = function _loop4() {
      var _greatest;

      var col = _step9.value;
      var colCount = typeCounts[col] = createTypeCount();

      var _iterator10 = _createForOfIteratorHelper(sample),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var d = _step10.value;
          var value = d[col];
          if (value == null) continue;

          var _type = _typeof(value);

          if (_type !== "string") {
            ++colCount.defined;
            if (Array.isArray(value)) ++colCount.array;else if (value instanceof Date) ++colCount.date;else if (value instanceof ArrayBuffer) ++colCount.buffer;else if (_type === "number") {
              ++colCount.number;
              if (Number.isInteger(value)) ++colCount.integer;
            } // bigint, boolean, or object
            else if (_type in colCount) ++colCount[_type];
          } else {
            value = value.trim();
            if (!value) continue;
            ++colCount.defined;
            ++colCount.string;

            if (/^(true|false)$/i.test(value)) {
              ++colCount.boolean;
            } else if (value && !isNaN(value)) {
              ++colCount.number;
              if (Number.isInteger(+value)) ++colCount.integer;
            } else if (DATE_TEST.test(value)) ++colCount.date;
          }
        } // Chose the non-string, non-other type with the greatest count that is also
        // ≥90%; or if no such type meets that criterion, fallback to string if
        // ≥90%; and lastly fallback to other.

      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      var minCount = Math.max(1, colCount.defined * 0.9);
      var type = (_greatest = greatest(types, function (type) {
        return colCount[type] >= minCount ? colCount[type] : NaN;
      })) !== null && _greatest !== void 0 ? _greatest : colCount.string >= minCount ? "string" : "other";
      schema.push({
        name: col,
        type: type,
        inferred: type
      });
    };

    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      _loop4();
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return schema;
}